import Vue from 'vue';
import _store from '@/store';
import {i18n} from '@/setup/i18n-setup';

export {_store as store};

//------------------------------------------------------------------------------------------------------//
//                                                                                                      //
//                                Variable                                                              //
//                                                                                                      //
//------------------------------------------------------------------------------------------------------//
export const state = {
  store: _store.state,
  // States from Vuex store
  local: Vue.observable({
    // Setup local state here (States which don't shared or long-term keeping);
    isProcessing: false,

    selectedSubject: null,
    selectedTeacher: null,
    selectedExamQuestionType: null,

    courseOutline: null,

    //the operator's per-upload override for the server's duplicate-question
    //check; false is the only safe initial value
    allowDuplicateQuestion: false,

    subjects: [],
    teachers: [],
    questionTypes: [],

    tableHeader: [
      // i18n.t('exam-upload.header.no'),
      i18n.t('exam-upload.header.unit'),
      i18n.t('exam-upload.header.question'),
      i18n.t('exam-upload.header.score'),
      i18n.t('exam-upload.header.answer'),
      i18n.t('exam-upload.header.choice-1'),
      i18n.t('exam-upload.header.choice-2'),
      i18n.t('exam-upload.header.choice-3'),
      i18n.t('exam-upload.header.choice-4'),
      i18n.t('exam-upload.header.random'),
      ]


  })
};


//------------------------------------------------------------------------------------------------------//
//                                                                                                      //
//                                Function                                                              //
//                                                                                                      //
//------------------------------------------------------------------------------------------------------//


export const loadData = async (func) => {

  if (state.local.selectedSubject && state.local.selectedSubject.id
  && state.local.selectedTeacher && state.local.selectedTeacher.id) {

    let payload = {
      courseOutlineFilterInput: {
        subjectId: state.local.selectedSubject ? state.local.selectedSubject.id : '',
        teacherId: state.local.selectedTeacher ? state.local.selectedTeacher.id : '',
      }
    };

    if (func.getCourseOutlinesByFilterForTable) {
      let result = await func.getCourseOutlinesByFilterForTable(payload);

      if(result && result.length > 0){
        state.local.courseOutline = result[0]
      }else {
        state.local.courseOutline = null
      }
    }
  }

};
